import { render, staticRenderFns } from "./sup-deposit-jeten.vue?vue&type=template&id=672dc342"
import script from "./sup-deposit-jeten.vue?vue&type=script&lang=js"
export * from "./sup-deposit-jeten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports